export const layoutIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
<!-- Document outline -->
<rect x="1" y="1" width="18" height="18" rx="2"/>

<!-- Left column (image) -->
<rect x="3" y="4" width="6" height="5" rx="0.5"/>

<!-- Right column (text lines) -->
<line x1="11" y1="4.5" x2="17" y2="4.5"/>
<line x1="11" y1="6.5" x2="17" y2="6.5"/>
<line x1="11" y1="8.5" x2="15" y2="8.5"/>

<!-- Bottom text lines -->
<line x1="3" y1="12" x2="17" y2="12"/>
<line x1="3" y1="14" x2="17" y2="14"/>
<line x1="3" y1="16" x2="13" y2="16"/>
</svg>
`;
